import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import logo from '../../../assets/images/logo.png';
import { useHistory } from 'react-router';
import { EXAM_DETAILS_ROUTE, HOME_ROUTE, OUR_INSTITUTES_ROUTE, WORK_WITH_US_ROUTE, FAQ_ROUTE, WEBINAR_SLPRB_ROUTE, OPPORTUNITIES_ROUTE, DASHBOARD_ROUTE } from '../../constants/route.constant';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { authService } from '../../services';
import { Typography } from '@material-ui/core';
import AndroidIcon from '@material-ui/icons/Android';
import AppleIcon from '@material-ui/icons/Apple';
import { PLAY_STORE_URL, APP_STORE_URL } from '../../constants/app.constant';

const useStyles = makeStyles(() => ({
  list: {
    width: 300,
  },
  fullList: {
    width: 'auto',
  },
  logo: {
    width: '68px',
    cursor: 'pointer',
  },
  title: {
    flexGrow: 1,
  },
  headerNav: {
    display: 'flex',
    
  },
  headerNavButtons: {
    paddingTop: '20px',
    paddingRight: '9px'
  },
  userName: {
    color: '#03A9F4'
  },
}));

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export const SideDrawer = ({ isOpen, handleClose, onLoginClick, onSignupClick }: any) => {
  const classes = useStyles();
  const anchor: Anchor = 'left';
  const history = useHistory();
  const { isLoggedIn, userName } = authService;

  const handleLogoClick = () => {
    history.push(HOME_ROUTE.path);
  }

  const navigate = (url: string) => {
    history.push(url);
  }

  const handleLogout = () => {
    authService.signOut();
    window.location.href = '/';
  }

  return (
    <Drawer anchor={anchor} open={isOpen} onClose={handleClose}>
      <div
        className={clsx(classes.list)}
        role="presentation"
        onClick={handleClose}
        onKeyDown={handleClose}
      >
        <div className={classes.headerNav}>
          <img onClick={handleLogoClick} className={classes.logo} src={logo} alt="logo" />
            <Typography variant="h6" className={classes.title}>
          </Typography>
          <div className={classes.headerNavButtons}>
            {
              !isLoggedIn && 
              <div>
                <Button onClick={onLoginClick} size="small" variant="contained" color="primary" className="white-text">
                    Login
                </Button>
                <Button onClick={onSignupClick} style={{marginLeft: '14px'}} size="small" variant="contained" color="secondary" className="white-text">
                    Signup
                </Button>
              </div>
            }

            {
              isLoggedIn &&
              <div className={classes.userName}>Hey {userName || 'User'}!</div>
            }
          </div>
        </div>
        <br/>

        <List>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('upsc-cse-2026'))}>
            <ListItemText primary='UPSC CSE' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('upsc-capf-2026'))}>
            <ListItemText primary='UPSC CAPF' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('upsc-cds-2026'))}>
            <ListItemText primary='UPSC CDS' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('cce-apsc-2026'))}>
            <ListItemText primary='APSC CCE' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('aes-apsc-2026'))}>
            <ListItemText primary='APSC AES' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('assam-direct-recruitment-exam-2026'))}>
            <ListItemText primary='ADRE' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('assam-police-si-2026'))}>
            <ListItemText primary='Assam Police SI' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('slprb-2026'))}>
            <ListItemText primary={<span className="nav-item-with-badge">SLPRB<span className="nav-new-badge">New</span></span>} />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('ssc-2026'))}>
            <ListItemText primary='SSC' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('railways-2026'))}>
            <ListItemText primary='Railways' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('bank-exams-2026'))}>
            <ListItemText primary='Banks' />
          </ListItem>
          <ListItem button onClick={() => navigate(EXAM_DETAILS_ROUTE.navigate('apdcl-2026'))}>
            <ListItemText primary='APDCL' />
          </ListItem>
          <ListItem button onClick={() => navigate(WEBINAR_SLPRB_ROUTE.path)}>
            <ListItemText primary={<span className="nav-item-with-badge">Webinars<span className="nav-new-badge">New</span></span>} />
          </ListItem>
          <ListItem button onClick={() => navigate(OPPORTUNITIES_ROUTE.path)}>
            <ListItemText primary={<span className="nav-item-with-badge">Opportunities<span className="nav-new-badge">New</span></span>} />
          </ListItem>
          <ListItem button onClick={() => navigate(OUR_INSTITUTES_ROUTE.path)}>
            <ListItemText primary='Contact Us' />
          </ListItem>
          <ListItem button onClick={() => navigate(WORK_WITH_US_ROUTE.path)}>
            <ListItemText primary='Work with us' />
          </ListItem>
          <ListItem button onClick={() => navigate(FAQ_ROUTE.path)}>
            <ListItemText primary='FAQs' />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button component="a" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            <ListItemIcon><AndroidIcon /></ListItemIcon>
            <ListItemText primary='Get the Android App' />
          </ListItem>
          <ListItem button component="a" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <ListItemIcon><AppleIcon /></ListItemIcon>
            <ListItemText primary='Get the iOS App' />
          </ListItem>
        </List>
        <Divider />
        <List>
          
          {
            isLoggedIn &&
            <>
              <ListItem button onClick={() => navigate(DASHBOARD_ROUTE.path)}>
                <ListItemIcon><AssessmentIcon /></ListItemIcon>
                <ListItemText primary={'My Reports'} />
              </ListItem>
              <ListItem button onClick={() => navigate('/profile')}>
                <ListItemIcon><PersonIcon /></ListItemIcon>
                <ListItemText primary={'Profile'} />
              </ListItem>
              <ListItem button onClick={handleLogout}>
                <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                <ListItemText primary={'Logout'} />
              </ListItem>
            </>
          }
          
        </List>
      </div>
    </Drawer>
  );
}
